import { render, staticRenderFns } from "./NuevoProfesional.vue?vue&type=template&id=293bb3a6&scoped=true"
import script from "./NuevoProfesional.vue?vue&type=script&lang=js"
export * from "./NuevoProfesional.vue?vue&type=script&lang=js"
import style0 from "./NuevoProfesional.vue?vue&type=style&index=0&id=293bb3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293bb3a6",
  null
  
)

export default component.exports